import API from './API.js';
export default class Degrees extends API {
    constructor() {
        super('degrees');
    }

}
